import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps {
  id: string;
  register: any;
  placeholder?: string;
  className?: string;
  autoComplete?: string;
  error?: boolean;
  focusColor?: 'teal' | 'red';
}

const PasswordInput = ({ 
  id, 
  register, 
  placeholder = "••••••••", 
  className = "", 
  autoComplete,
  error = false,
  focusColor = 'teal'
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Base classes for UserProfile page styling
  const focusRingColor = focusColor === 'red' ? 'focus:ring-red-500' : 'focus:ring-secondary-500';
  const baseClasses = `w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${focusRingColor} focus:border-transparent text-gray-900 ${
    error ? 'border-red-500' : 'border-gray-300'
  }`;

  return (
    <div className="relative">
      <input
        id={id}
        type={showPassword ? "text" : "password"}
        autoComplete={autoComplete}
        {...register}
        className={`${baseClasses} ${className} pr-10`}
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 focus:outline-none"
        tabIndex={-1}
      >
        {showPassword ? (
          <EyeOff className="h-5 w-5" />
        ) : (
          <Eye className="h-5 w-5" />
        )}
      </button>
    </div>
  );
};

export default PasswordInput;
